import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  productAddButton: {
    textDecoration: 'none !important',
    fontSize: pxToRem(14),
  },
  saveDimensionListItemButton: {
    position: 'absolute',
    right: pxToRem(1),
    top: pxToRem(40),
  },
  root: {
    backgroundColor: theme.palette.white,
    position: 'relative',
    padding: pxToRem(14),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  toggleCloseButton: {
    position: 'absolute',
    color: theme.palette.neutralDark,
    right: pxToRem(15),
    top: pxToRem(10),
    selectors: {
      ':hover': {
        color: theme.palette.themeDarker,
      },
    },
  },
  detailRowIcon: {
    fontSize: pxToRem(16),
  },
  listsHeader: {
    selectors: {
      '&[class^=isOpen-]': {
        marginLeft: pxToRem(0),
        paddingRight: 0,
      },
      '&[class^=isOpen-] > span': {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
      },
    },
  },
  itemsTitle: {
    fontSize: pxToRem(14),
    color: theme.palette.neutralDark,
  },
  itemText: {
    fontSize: pxToRem(14),
  },
  iconColumn: {
    justifyContent: 'end',
  },
  table: {
    minHeight: pxToRem(100),
    maxHeight: pxToRem(450),
    overflowY: 'auto',
    width: 'fit-content',
    marginBottom: pxToRem(24),
    '.ms-DetailsRow-cell:last-of-type': {
      textAlign: 'right',
      padding: 0,
    },
    '.ms-DetailsHeader-cell:last-of-type': {
      backgroundColor: 'transparent',
    },
    '.ms-DetailsHeader-cell:last-of-type span': {
      color: theme.palette.themePrimary,
      cursor: 'pointer',
    },
    '.ms-DetailsHeader-cell:last-of-type span:hover': {
      textDecoration: 'underline',
    },
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    '.ms-Button--default': {
      marginRight: pxToRem(16),
    },
  },
  cancelButton: {
    fontWeight: 400,
  },
  scrollablePane: {
    minHeight: pxToRem(100),
    maxHeight: pxToRem(450),
    overflowY: 'auto',
    width: 'fit-content',
  },
  removeIconColumn: {
    justifyContent: 'center',
  },
});
